'use client'

import React, { useState } from 'react'
import { CheckboxIcon, DownIcon } from '@/_assets/icon-components'

import { IRedux } from '@/_store/types'

import {
  PopoverBody,
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from '@/components/ui/popover'
import { RadioCardItem, RadioCardRoot } from '@/components/ui/radio-card'
import { Box, HStack, Stack, StackSeparator } from '@chakra-ui/react'

import { useTranslations } from 'next-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import { IProps } from '.'
import { sessionActions } from '@/_store/session/session.slice'

const DeliveryMobile = ({ handleOpenMap }: IProps) => {
  const [open, setOpen] = useState(false)

  const { data } = useSelector((state: IRedux) => state.settings)
  const { order_type } = useSelector((state: IRedux) => state.session)
  const t = useTranslations()
  const dispatch = useDispatch()

  const filteredOrderTypes = data?.data?.order_types?.filter(
    (orderType) =>
      orderType.type === 'delivery' || orderType.type === 'self-pickup',
  )

  const handleSelectOrderType = (value: string | null) => {
    const activeOrderType = data?.data?.order_types?.find(
      (orderType) => orderType.type === value,
    )
    if (activeOrderType) {
      dispatch(sessionActions.saveOrderType(activeOrderType))
    }

    setOpen(false)
    if (value === 'self-pickup') handleOpenMap(value)
  }

  if (!order_type?.type) {
    return null
  }

  return (
    <>
      <PopoverRoot open={open} onOpenChange={(e) => setOpen(e.open)}>
        <PopoverTrigger asChild>
          <Button
            size='md'
            rounded={12}
            variant='outline'
            color='text'
            bg='transparent'
            _hover={{ bg: 'transparent' }}
            _active={{ bg: 'transparent' }}
          >
            {t(order_type?.type)}
            <Box
              transform={open ? 'rotate(180deg)' : 'rotate(0deg)'}
              transition='transform 0.3s ease'
            >
              <DownIcon />
            </Box>
          </Button>
        </PopoverTrigger>
        <PopoverContent w={'165px'} rounded={12} bg='background' color='text'>
          <PopoverBody p={2}>
            <RadioCardRoot unstyled value={order_type?.type}>
              <Stack
                separator={<StackSeparator />}
                w={'full'}
                flexDir={'column'}
                justifyContent={'space-between'}
              >
                {filteredOrderTypes?.map((el) => (
                  <HStack
                    key={el.id}
                    w={'full'}
                    flexDir={'row-reverse'}
                    justifyContent={'space-between'}
                    onClick={() => handleSelectOrderType(el?.type)}
                    fontSize={'sm'}
                  >
                    <RadioCardItem
                      icon={
                        order_type?.type === el.type ? (
                          <CheckboxIcon
                            size={20}
                            color={'var(--primary-default)'}
                          />
                        ) : (
                          <Box bg={'light.300'} w={5} h={5} rounded={'full'} />
                        )
                      }
                      value={el.type}
                      id={el.id}
                      indicator={false}
                      border={'none'}
                    />
                    <label htmlFor={el.id}>{t(el.type)}</label>
                  </HStack>
                ))}
              </Stack>
            </RadioCardRoot>
          </PopoverBody>
        </PopoverContent>
      </PopoverRoot>
    </>
  )
}

export default DeliveryMobile
